import { Textarea } from '@mantine/core';
import classes from '../input.module.css';
import { defaultInputProps } from '../default-props';
export const textAreaProps = Textarea.extend({
    classNames: classes,
    defaultProps: defaultInputProps,
});
